import { Component } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { DialogActionPracticeComponent } from '@pages/tables/action-practices/dialog-action-practice/dialog-action-practice.component';
import { ActionPracticesModel } from '@/models/tables/action-practices.model';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-button-new-action-practice',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonNewActionPracticeComponent extends ButtonComponent {
  private dialogOpened: MatDialogRef<any>;
  faIcon = faPenToSquare;

  constructor(
    protected router: Router,
    protected toastr: ToastrService,
    private dialog: MatDialog,
  ) {
    super(router, toastr);

    this.showIcon = false;
    this.additionalClass = 'ml-2';
    this.content = 'Nuova Azione pratica';
  }

  /**
   * Open modal new detail page
   */
  public actionClick(): void {
    this.dialogOpened = this.dialog.open(DialogActionPracticeComponent, {
      data: new ActionPracticesModel(),
    });

    Registry.getInstance().set('DialogActionPracticeComponentNew', this.dialogOpened);
  }
}
